import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

const UF_TO_INFO: Record<string, { num: string, name: string, full_name: string }> = {
  AC: { num: "02", name: "acre", full_name: "Acre" },
  AL: { num: "03", name: "alagoas", full_name: "Alagoas" },
  AP: { num: "04", name: "amapa", full_name: "Amapá" },
  AM: { num: "05", name: "amazonas", full_name: "Amazonas" },
  BA: { num: "06", name: "bahia", full_name: "Bahia" },
  CE: { num: "07", name: "ceara", full_name: "Ceará" },
  DF: { num: "08", name: "distrito-federal", full_name: "Distrito Federal" },
  ES: { num: "09", name: "espirito-santo", full_name: "Espírito Santo" },
  GO: { num: "10", name: "goias", full_name: "Goiás" },
  MA: { num: "11", name: "maranhao", full_name: "Maranhão" },
  MT: { num: "12", name: "mato-grosso", full_name: "Mato Grosso" },
  MS: { num: "13", name: "mato-grosso-do-sul", full_name: "Mato Grosso do Sul" },
  MG: { num: "14", name: "minas-gerais", full_name: "Minas Gerais" },
  PA: { num: "15", name: "para", full_name: "Pará" },
  PB: { num: "16", name: "paraiba", full_name: "Paraíba" },
  PR: { num: "17", name: "parana", full_name: "Paraná" },
  PE: { num: "18", name: "pernambuco", full_name: "Pernambuco" },
  PI: { num: "19", name: "piaui", full_name: "Piauí" },
  RJ: { num: "20", name: "rio-de-janeiro", full_name: "Rio de Janeiro" },
  RN: { num: "21", name: "rio-grande-do-norte", full_name: "Rio Grande do Norte" },
  RS: { num: "22", name: "rio-grande-do-sul", full_name: "Rio Grande do Sul" },
  RO: { num: "23", name: "rondonia", full_name: "Rondônia" },
  RR: { num: "24", name: "roraima", full_name: "Roraima" },
  SC: { num: "25", name: "santa-catarina", full_name: "Santa Catarina" },
  SP: { num: "26", name: "sao-paulo", full_name: "São Paulo" },
  SE: { num: "27", name: "sergipe", full_name: "Sergipe" },
  TO: { num: "28", name: "tocantins", full_name: "Tocantins" },
  BR: { num: "01", name: "brasil", full_name: "Brasil" }
};

export function StateFlagCell({ uf }: { uf: string }) {
  const info = UF_TO_INFO[uf];
  const flagUrl = info
    ? `https://raw.githubusercontent.com/pierrelapalu/icones-bandeiras-br-uf/master/dist/rounded/png-200/${info.num}-${info.name}-rounded.png`
    : undefined;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="flex items-center gap-2 cursor-pointer">
            {flagUrl ? (
              <img
                src={flagUrl}
                alt={`Bandeira de ${uf}`}
                className="w-6 h-4 border rounded"
                style={{ objectFit: "cover" }}
                onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = "none"; }}
              />
            ) : (
              <div className="w-6 h-4 bg-gray-200 flex items-center justify-center border rounded text-xs">--</div>
            )}
            <span>{uf}</span>
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <span>{info?.full_name ?? uf}</span>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
